var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvalidation = function SvgInvalidation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 75 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    x: 27.43,
    y: 3,
    fill: "currentColor",
    rx: 2.484
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    y: 3.779,
    fill: "currentColor",
    opacity: 0.4,
    rx: 2.484
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    x: 27.43,
    y: 30.017,
    fill: "currentColor",
    opacity: 0.4,
    rx: 2.484
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    x: 53.668,
    y: 56.255,
    fill: "currentColor",
    opacity: 0.4,
    rx: 2.484
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    x: 53.668,
    y: 29.592,
    fill: "currentColor",
    rx: 2.484
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    y: 57.035,
    fill: "currentColor",
    rx: 2.484
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 20.099,
    height: 20.263,
    x: 54.23,
    y: 3.366,
    fill: "currentColor",
    opacity: 0.4,
    rx: 2.484
  })));
};
export default SvgInvalidation;